/**
 * Match strategies provides customized client side cache matching logic, so
 * that the cached results with same/similar keys may be reused to improve cache
 * hit rate.
 */
export class MatchStrategy {
  /**
   * Initialize a cache manager for applying the match strategy
   * @param {ClientCacheManager} cacheManager - The cache manager to initialize
   * @returns {void}
   */
  initializeCacheManager(/* cacheManager */) {
  }

  /**
   * Find a cached value matching the key according to the match strategies
   * @abstract
   * @param {ClientCacheManager} cacheManager - The client cache manager
   * @param {ClientCacheKey} key - The cache key
   * @returns {*} - The value matching the given key. Return null for no match.
   */
  match(/* cacheManager, key */) {
    return null;
  }
}
